<template>
    <el-tree-select
        v-model="data"
        :data="materialTypeList"
        :render-after-expand="false"
        :placeholder="i18n.tkey('lang_select_product_pls')"
        @change="changeValue"
        style=""
    />
</template>

<script setup>

import {inject, onBeforeMount, ref, toRef, watch} from "vue";
import whatsShopsBCataApi from "@/request/whatsShopsBCataApi";
import myUtil from "@/util/util";
import {useUserinfo} from "@/stores/userinfo";

const props = defineProps(['modelValue'])
const emits = defineEmits(['update:modelValue', "changeSelect"])

const i18n = inject("i18n")

const data = ref(null)
const materialTypeList = ref([])

const userInfoRef = toRef(useUserinfo())

watch(() => props.modelValue, (newValue, oldValue) => {
    data.value = props.modelValue
});

function getMaterialTypeList(){
    const request = whatsShopsBCataApi.getAllProdutTypeWithOutType
    const params = request.getParams()

    request.send(params, (res) => {
        if (res.code == 200){
            fillMaterialType(res.detail)
        }else{
            myUtil.alertError(res.msg)
        }
    })

}
let typedata = {
  "id": 1,
  "companycode": "A",
  "bcatacode": "",
  "langen": "All",
  "langhk": "全部",
  "langcn": "",
  "lang1": "",
  "lang2": "",
  "mssqlno": "",
  "updatedid": 0,
  "itemno": null,
  "ttlqty": 0,
  "child": [],
  "countNum": 0
}
function fillMaterialType(obj){
    let allTypeList = []
    const list = []

    allTypeList.push(typedata)
    allTypeList = allTypeList.concat(obj.list01)
    allTypeList = allTypeList.concat(obj.list00)
    allTypeList = allTypeList.concat(obj.list02)

    allTypeList.forEach((v, i) => {
        const obj = generateTypeObj(v)
        obj.value = obj.value.substring(0, 4)

        if (null != v.child && v.child.length > 0){
            v.child.forEach((value, index) => {
                const subObj = generateTypeObj(value)
                subObj.value = subObj.value.substring(0, 6)
                obj.children.push(subObj)
            })
        }

        list.push(obj)
    })
    materialTypeList.value = list
}

function generateTypeObj(data){
    const obj = {
        value: data.bcatacode,
        label: data.langen,
        children: []
    }

    if (userInfoRef.value.lang === "zh" || userInfoRef.value.lang === "szh" || myUtil.isEmpty(data.langen)){
        obj.label = data.langhk
    }

    return obj
}

function changeValue(){
    emits("update:modelValue", data.value)
    emits("changeSelect")
}

onBeforeMount(() => {
    data.value = props.modelValue

    getMaterialTypeList()
})

</script>

<style scoped>

</style>